<template>
  <div>
    <body>
      
      <div class="tutor_mobile">
        <img :src="complete_mobile" />
      </div>
      <div class="tutor_wrap" :style="{ background: 'url(\'' + complete_pc + '\') no-repeat center top' }">
      </div>
    </body>
  </div>
</template>

<script>
export default {
    name: 'CarrotSolutionsFinish',

    data() {
        return {
          complete_pc : '',
          complete_mobile : '',
        };
    },

    mounted() {
      let url = "";
    if (location.href.includes("local") || location.href.includes("stage")) {
        url = "https://stageapi.carrotians.net/rest/external/getHolidayGiftManagement";
      } else {
        url = "https://api.carrotians.net/rest/external/getHolidayGiftManagement";
      }
      this.axios.get(url).then((res) => {
        console.log(res.data.data)
        this.complete_pc = res.data.data.complete_pc
        this.complete_mobile = res.data.data.complete_mobile
      })
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/style/holiday_gift/common.css";
@import "../assets/style/holiday_gift/style.css";
</style>